import type { TreeTag } from '#domains/tags';

const filterAncestors = (tags: TreeTag[], tag: TreeTag) => {
  if (!tag.ancestors) {
    return [tag];
  }

  const ancestorsArray = tag.ancestors.split('/');

  return tags.filter(t => ancestorsArray.includes(t.id));
};

export default filterAncestors;
